import type { ReactNode } from "react";

export function SimpleTable<T extends Record<string, unknown>>({
  columns,
  rows,
  empty,
}: {
  columns: { key: string; title: string; render: (row: T) => ReactNode }[];
  rows: T[];
  empty: string;
}) {
  if (rows.length === 0) {
    return <div className="px-4 py-12 text-center text-sm text-tribal-muted">{empty}</div>;
  }
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-left text-sm">
        <thead className="text-xs uppercase tracking-wide text-tribal-muted">
          <tr className="border-b border-tribal-border">
            {columns.map((c) => (
              <th key={c.key} className="px-4 py-3 font-medium">
                {c.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-tribal-border/60">
          {rows.map((row, idx) => (
            <tr key={idx} className="hover:bg-white/[0.02]">
              {columns.map((c) => (
                <td key={c.key} className="px-4 py-2">
                  {c.render(row) ?? "-"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
